module.exports = __webpack_public_path__ + "static/media/health-assist-america.624fb542.svg";